import Home from './index';
import Survey from './components/SurveyStart';
import Answer from './components/SurveyAnswer';
import Result from './components/SurveyResult';
import AnswerMvp from './components/SurveyAnswerMvp';
import Error from './components/SurveyError';
import Report from './components/SurveyReport';

interface RouterProps {
    path: string;
    element: React.ReactNode;
}

const RoutesList: RouterProps[] = [
    {
        path: '/',
        element: <Home />,
    },
    {
        path: '/s/:id',
        element: <Survey />,
    },
    {
        path: '/s/:sid/anwsersheets/:id',
        element: <Answer />,
    },
    {
        path: '/s/:id/answer',
        element: <Answer />,
    },
    {
        path: '/s/:id/result',
        element: <Result />,
    },
    {
        path: '/s/error',
        element: <Error />,
    },
    {
        path: '/s/:id/report',
        element: <Report />,
    },

    // 仅支持组织学习 - 培训调研任务作答相关操作
    {
        path: '/s/:id/answerMvp',
        element: <AnswerMvp />,
    },
    {
        path: '/s/:sid/answersheetsMvp/:id',
        element: <AnswerMvp />,
    },
];

export default RoutesList;
